import React from "react";
import { FormGroup, Input } from "reactstrap";


function SelectorPlanes(props){
    const {Valor, setValor, arrayElementos, titulo} = props;
    
    const cambiarValor = event => {
        setValor(event.target.value);
    };

    return(
        <>
            <FormGroup>
                    <Input id="exampleFormControlSelect1" type="select" 
                        value={Valor}
                        onChange={cambiarValor}
                    >
                        {titulo?
                        <option value={''}>{titulo}</option>
                        :
                        <option value={''}>Opciones..</option>
                        }
                        {arrayElementos?
                        
                        arrayElementos.map((ele, index) => {
                            return(
                                <option key={index} value={ele.id}>{ele.name} ( $ { ele.price } )</option>

                            )
                        })
                        :
                        <option value={''}>Cargando..</option>
                        }
                    </Input>
            </FormGroup>
        </>
    );
};

export default SelectorPlanes;